// THE PRODUCT TOUR — step table (Brightivity, m11 #11). Forked from app/src/components/tour/tourSteps.js: same
// engine and rules, Brightivity pages and copy. Data only: no DOM, no React, no copy.
//
// ANCHOR CONTRACT. Every `target` is a `data-tour="<id>"` attribute on a real element. Adding a step means three
// edits: an entry here, the attribute at the anchor, and its copy under `steps.<id>` in `src/locales/en/tour.json`.
// A step whose anchor never shows up degrades to a centred card — it never blocks and never points at nothing.
//
// `page` is the Brightivity route the step lives on (PAGE_PATHS); the tour navigates there and waits for the anchor.
// interactive / gate / before / after work as on desktop (tourRuntime.js). Every gated step offers "Skip for now".
// Order follows desktop: printing first, then Canva, Printables, the AI Poster Maker, Design, Scan.

// Bumping this version re-prompts everyone who already finished the old tour.
export const TOUR_VERSION = 'v1';
export const TOUR_STORAGE_KEY = 'bv_tour_' + TOUR_VERSION;

export const TOUR_STEPS = [
  // ── Print ── SETUP STEP: connect a school computer / find a printer; Next unlocks once a printer is listed.
  { id: 'print-discovery', page: 'print', target: '[data-tour="print-discovery"]', placement: 'left', interactive: true, gate: 'printerFound', before: 'openPrintersBox' },
  { id: 'print-inks', page: 'print', target: '[data-tour="print-inks"]', placement: 'left', before: 'openInkBox' },
  { id: 'print-dropzone', page: 'print', target: '[data-tour="print-dropzone"]', placement: 'right' },
  { id: 'print-preview', page: 'print', target: '[data-tour="print-preview"]', placement: 'bottom' },
  // ── Canva ──
  { id: 'browser-sites', page: 'browser', target: '[data-tour="browser-sites"]', placement: 'bottom' },
  { id: 'library-canva', page: 'library', target: '[data-tour="library-canva-tab"]', placement: 'bottom' },
  // ── Printables ──
  { id: 'printables-filters', page: 'printables', target: '[data-tour="printables-filters"]', placement: 'right' },
  { id: 'printables-collections', page: 'printables', target: '[data-tour="printables-collections"]', placement: 'left' },
  // ── AI Poster Maker ──
  { id: 'hero-generate', page: 'home', target: '[data-tour="hero-generate"]', placement: 'bottom' },
  { id: 'generator-form', page: 'ai', target: '[data-tour="generator-form"]', placement: 'right' },
  // ── Design ──
  { id: 'editor-tools', page: 'design', target: '[data-tour="editor-tools"]', placement: 'right' },
  { id: 'editor-ribbon', page: 'design', target: '[data-tour="editor-ribbon"]', placement: 'bottom' },
  // ── Scan ──
  { id: 'scan-panel', page: 'scan', target: '[data-tour="scan-panel"]', placement: 'right' },
  // ── Close ── no anchor: back on Home, says where the replay lives.
  { id: 'finish', page: 'home', target: null, placement: 'center' },
];

// Brightivity routes for the step pages (desktop used navigate-to-* window events).
export const PAGE_PATHS = {
  home: '/',
  print: '/print',
  browser: '/browser',
  printables: '/printables',
  design: '/design',
  ai: '/design/ai',
  scan: '/scan',
  library: '/library',
};
